<template>
  <div class="care-plan-card-slider-wrapper">
    <div class="care-plan-card-slider-container">
      <div class="slider-outer"></div>
      <div class="slider-inner">
        <div
          id="care-plan-card-slider-inner"
          class="care-plan-card-list-wrapper">
          <div
            v-if="sliderTotalNumber"
            class="care-plan-card-list"
            :class="{'plan-compatibility': displayConfig.isPlanCompatible}"
            :style="`transform: translateX(${moveDistance}px)`">
            <care-plan-card
              v-for="item in planCardList" :key="item.planKeyName"
              class="care-plan-card-item"
              :is-annual-active="isAnnualActive"
              :is-feature-active-map="item.isFeatureActiveMap"
              :plan-key-name="item.planKeyName"
              :plan-price="item.planPrice[priceKeyName]"
              :plan-special-price="item.planSpecialPrice[priceKeyName]"
              :event-video-day="item.featureData.eventVideoDay"
              :continuous-video-day="item.featureData.continuousVideoDay"
              :camera-share-cnt="item.featureData.cameraShareCnt"
              :sleeplog-history-day="item.featureData.sleeplogHistoryDay"
              :snapcute-cnt="item.featureData.snapcuteCnt"
              :show-tag="item.showTag">
            </care-plan-card>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import displayConfig from '../../configs/displayConfig';
import CarePlanCard from '../care/CarePlanCard.vue';

export default {
  name: 'care-plan-card-slider',
  components: {
    CarePlanCard,
  },
  props: {
    isAnnualActive: {
      type: Boolean,
      required: true,
    },
    planCardList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      displayConfig,
      /** 移動距離 */
      moveDistance: 0,
      moveNumberPerAction: 1,
      /** 單一 camera review 的寬度，不包含 margin */
      singleSliderInnerWidth: 280,
      /** slider 現在的 index */
      sliderCurrentIndex: 0,
      sliderInitIndex: 0,
      /** slider 總數 */
      // sliderTotalNumber: 4,
      swipeData: {
        touchStart: 0,
        touchEnd: 0,
        distance: 0,
      },
    };
  },
  computed: {
    isLastPage() {
      return this.sliderCurrentIndex + this.moveNumberPerAction >= this.sliderTotalNumber;
    },
    isMobileLayout() {
      return window.innerWidth <= 768;
    },
    lastSlideNumber() {
      /** 用來判斷結束動作的 slide 數量 */
      if (window.innerWidth >= 768) {
        return this.sliderTotalNumber - 1;
      }

      return this.sliderTotalNumber;
    },
    priceKeyName() {
      if (this.isAnnualActive) {
        return 'yr';
      }

      return 'mo';
    },
    totalPageNumber() {
      return this.sliderTotalNumber / this.moveNumberPerAction;
    },
    sliderStartXPosition() {
      /** slider 起始位置 */
      if (window.innerWidth <= 576) {
        return -0.5 * this.singleSliderWidth + (window.innerWidth * 0.4);
      }

      return 0;
    },
    singleSliderWidth() {
      /** sldier 寬度，含 margin */
      if (window.innerWidth <= 768) {
        return this.singleSliderInnerWidth + 16 * 2;
      }

      return this.singleSliderInnerWidth + 36 * 2;
    },
    sliderTotalNumber() {
      // slider 總數
      if (displayConfig.isPlanCompatible) {
        return 7;
      }

      return 4;
    },
  },
  watch: {
    sliderCurrentIndex(newValue) {
      this.moveDistance = this.sliderStartXPosition - this.singleSliderWidth * newValue;
    },
    'swipeData.distance': {
      handler(value) {
        if (Math.abs(value) < (window.innerWidth / 10)) {
          return;
        }

        if (value > 0) {
          this.prev();
          return;
        }

        this.next();
      },
      immediate: true,
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.init();
    });
  },
  methods: {
    init() {
      this.moveDistance = this.sliderStartXPosition;
      this.sliderCurrentIndex = this.sliderInitIndex;
      this.detectSwipe();
    },
    detectSwipe() {
      const element = document.getElementById('care-plan-card-slider-inner');
      const self = this;

      element.addEventListener('touchstart', (e) => {
        self.swipeData.touchStart = e.touches[0].clientX;
      }, false);

      element.addEventListener('touchend', (e) => {
        self.swipeData.touchEnd = e.changedTouches[0].clientX;
        self.calculateSwipeDistance();
      }, false);
    },
    calculateSwipeDistance() {
      this.swipeData.distance = this.swipeData.touchEnd - this.swipeData.touchStart;
    },
    prev() {
      const { sliderCurrentIndex, moveNumberPerAction, lastSlideNumber } = this;
      this.sliderCurrentIndex = (sliderCurrentIndex - moveNumberPerAction + lastSlideNumber)
        % lastSlideNumber;
    },
    next() {
      const { sliderCurrentIndex, moveNumberPerAction, lastSlideNumber } = this;

      this.sliderCurrentIndex = (sliderCurrentIndex + moveNumberPerAction) % lastSlideNumber;
    },
    checkIsCurrentPage(index) {
      return Math.floor(this.sliderCurrentIndex / this.moveNumberPerAction) === (index - 1);
    },
  },
};
</script>
<style lang="sass" scoped>
// only mobile layout, iPad, iPad Pro would use this component
.care-plan-card-slider-wrapper
  width: 120%
  .care-plan-card-slider-container
    width: 100%
    height: 100%
    .slider-outer
    .slider-inner
      width: 100%
      height: 100%
      overflow: hidden
      display: flex
      justify-content: center
      align-items: flex-start
      .care-plan-card-list-wrapper
        /** sldier 寬度，含 margin */
        --single-slider-width: 312px
        width: calc(var(--single-slider-width) *2.6 )
        height: 100%
        overflow-x: hidden
        overflow-y: hidden
        display: flex
        .care-plan-card-list
          display: flex
          flex-direction: row-reverse
          justify-content: center
          align-items: center
          width: max-content
          height: 100%
          padding: 32px 0px
          transition: all 1s ease-in-out
          &.plan-compatibility
            flex-direction: row
          .care-plan-card-item
            margin: 0 32px

@media screen and (max-width: 768px)
  .care-plan-card-slider-wrapper
    .care-plan-card-slider-container
      .slider-inner
        .care-plan-card-list-wrapper
          display: block
          width: calc(var(--single-slider-width) *2 )
          .care-plan-card-list
            .care-plan-card-item
              margin: 0 16px
</style>
